module.exports = __webpack_public_path__ + "media/inventory_open.ed3b6478.wav";